
const ConciergeSection = () => {
  return (
    <section className="py-20" style={{ backgroundColor: '#F8F4EF' }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="bg-white rounded-3xl p-8 lg:p-16 shadow-sm border" style={{ borderColor: '#C9B8A4' }}>
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Left Content */}
            <div>
              <div className="flex items-center space-x-3 mb-6">
                <div 
                  className="w-12 h-12 rounded-xl flex items-center justify-center"
                  style={{ backgroundColor: '#E6DACD' }}
                >
                  <i 
                    className="ri-robot-line text-2xl"
                    style={{ color: '#7B6655' }}
                  ></i>
                </div>
                <div 
                  className="px-4 py-1 rounded-full text-sm font-semibold text-white"
                  style={{ backgroundColor: '#7B6655' }}
                >
                  Featured Add-On
                </div>
              </div>
              
              <h2 
                className="text-4xl lg:text-5xl font-bold mb-6"
                style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}
              >
                NextPhase Concierge AI™
              </h2>
              
              <div className="mb-6">
                <span 
                  className="text-3xl font-bold"
                  style={{ color: '#7B6655', fontFamily: 'Manrope, Inter, sans-serif' }}
                >
                  $1,750 – $2,500
                </span>
                <span 
                  className="text-lg ml-2"
                  style={{ color: '#2B2B2B' }}
                >
                  setup + $400–$800/mo
                </span>
              </div>
              
              <p 
                className="text-xl mb-8 leading-relaxed"
                style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}
              >
                "Replaces a $45,000+/yr receptionist or admin role with a consistent, 24/7 intake, scheduling, and qualification pipeline — integrated directly into your CRM."
              </p>
              
              <div className="space-y-4 mb-8">
                {[
                  "Answers inbound calls professionally",
                  "Qualifies leads based on your criteria", 
                  "Books appointments in your calendar",
                  "Updates CRM records automatically",
                  "Sends follow-up messages",
                  "Available 24/7, never takes a sick day"
                ].map((feature, index) => (
                  <div key={index} className="flex items-center space-x-3">
                    <div 
                      className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0"
                      style={{ backgroundColor: '#E6DACD' }}
                    >
                      <i 
                        className="ri-check-line text-sm"
                        style={{ color: '#7B6655' }}
                      ></i>
                    </div>
                    <span 
                      style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}
                    >
                      {feature}
                    </span>
                  </div>
                ))}
              </div>
              
              <button 
                onClick={() => document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' })}
                className="px-8 py-4 rounded-lg font-semibold text-white transition-all duration-200 whitespace-nowrap cursor-pointer hover:opacity-90"
                style={{ backgroundColor: '#7B6655', fontFamily: 'Manrope, Inter, sans-serif' }}
              >
                Learn More About Concierge AI™
              </button>
            </div>

            {/* Right Content - Visual */}
            <div className="hidden lg:flex justify-center items-center">
              <div className="relative">
                <div 
                  className="w-80 h-80 rounded-3xl flex items-center justify-center"
                  style={{ backgroundColor: '#F8F4EF' }}
                >
                  <div className="text-center">
                    <div 
                      className="w-24 h-24 rounded-full flex items-center justify-center mx-auto mb-6"
                      style={{ backgroundColor: '#E6DACD' }}
                    >
                      <i 
                        className="ri-customer-service-2-line text-4xl"
                        style={{ color: '#7B6655' }}
                      ></i>
                    </div>
                    <h3 
                      className="text-2xl font-bold mb-2"
                      style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}
                    >
                      24/7 AI Assistant
                    </h3>
                    <p 
                      style={{ color: '#7B6655', fontFamily: 'Inter, sans-serif' }}
                    >
                      Never miss a lead again
                    </p>
                  </div>
                </div>
                
                {/* Floating elements */}
                <div 
                  className="absolute -top-4 -right-4 w-16 h-16 rounded-full flex items-center justify-center animate-pulse"
                  style={{ backgroundColor: '#7B6655' }}
                >
                  <i className="ri-phone-line text-white text-xl"></i>
                </div>
                
                <div 
                  className="absolute -bottom-4 -left-4 w-16 h-16 rounded-full flex items-center justify-center animate-pulse"
                  style={{ backgroundColor: '#C9B8A4', animationDelay: '1s' }}
                >
                  <i 
                    className="ri-calendar-check-line text-xl"
                    style={{ color: '#7B6655' }}
                  ></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConciergeSection;
